"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedText = exports.RequiredFieldsInfo = exports.SpinnerWrapper = exports.CancelEditLink = exports.DeleteArea = exports.OfferStepFooter = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.OfferStepFooter = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 3rem 0;
	${(0, styled_breakpoints_1.down)('xs')} {
		flex-direction: column;
		button:first-child {
			margin-bottom: 16px;
		}
	}
`;
exports.DeleteArea = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin: 3rem 0;
	font-weight: bold;
`;
exports.CancelEditLink = (0, styled_components_1.default)(elements_1.Link) `
	margin-left: 1rem;
	text-decoration: underline;
	color: ${({ theme }) => theme.color.gray7};
	&:link,
	&:visited,
	&:active,
	&:hover {
		color: ${({ theme }) => theme.color.gray7};
	}
`;
exports.SpinnerWrapper = styled_components_1.default.div `
	text-align: center;
	margin: 6rem 0;
`;
exports.RequiredFieldsInfo = styled_components_1.default.div `
	text-align: center;
`;
exports.RedText = styled_components_1.default.span `
	color: #f6512c;
	line-height: 1;
	content: '*';
	font-size: 14px;
	font-family: SimSun, sans-serif;
	margin-right: 4px;
	display: inline-block;
`;
